<template>
  <div style="background-color: #f5f5f5;">
    <Topo />
    <b-container>
      <b-card-group deck class="mb-5">
        <b-card bg-variant="white" text-variant="black" header-tag="header" class="text-center">
          <template v-slot:header>
            <b>Já estou inscrito(a)</b>
          </template>
          <Login />
        </b-card>
        <!-- <b-card bg-variant="white" text-variant="black" header-tag="header" class="text-center">
          <template v-slot:header>
            <b>Quero me inscrever</b>
          </template>
          <Inscricao />
        </b-card> -->
        <b-card bg-variant="white" text-variant="black" header-tag="header" class="text-center">
          <template v-slot:header>
            <b>Quero me inscrever</b>
          </template>
          <div class="pt-5 text-danger"><b>Inscrições encerradas!</b></div>
        </b-card>
      </b-card-group>
    </b-container>
  </div>
</template>

<script>
import Topo from '@/components/Topo.vue'
import Login from '@/components/Login.vue'
// import Inscricao from '@/components/Inscricao.vue'

export default {
  name: 'Home',
  // components: { Topo, Login, Inscricao },
  components: { Topo, Login },
  data () {
    return {
      dataAtual: this.$moment().subtract(3, 'hours'),
      dataFinal: this.$moment('2020-10-06 23:59:00') // .format('DD/MM/YYYY')
    }
  }
}
</script>
